export default __webpack_public_path__ + "static/media/ac_spo.b18dc574.bmp";